// @flow
import type { State } from 'types/redux';
import type { IContactInfo } from './IContactInfo';
import { createSelector } from 'reselect';

export function getContactInfo(state: State): IContactInfo {
  return state.appointment.contactInfo;
}

export const getEmail = createSelector(
  getContactInfo,
  ({ email }: { email: string }) => email
);

export const getPhone = createSelector(
  getContactInfo,
  ({ phone }: { phone: string }) => phone
);

export const getMobilePhone = createSelector(
  getContactInfo,
  ({ mobilePhone }: { mobilePhone: string }) => mobilePhone
);

export const getObfuscatedBy = createSelector(
  getContactInfo,
  ({ obfuscatedBy }: { obfuscatedBy?: string }) => obfuscatedBy
);

export const getIsObfuscated = createSelector(
  getObfuscatedBy,
  (obfuscatedBy: string) => Boolean(obfuscatedBy)
);

export const getIsMobileObfuscated = createSelector(
  getContactInfo,
  ({ mobilePhone }: { mobilePhone?: string }) =>
    mobilePhone && mobilePhone.indexOf('*') > -1
);



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/contactInfo/selectors.js